@if (object) {
  @if (isIssdActivity && issdApplication) {
    <icz-tag [label]="issdApplication!.name" color="orange" class="mr-16" (click.stop)="openUrl(issdApplication!.urlAddress)" [ngClass]="{'clickable-tag': issdApplication!.urlAddress}"></icz-tag>
  }
  @if (isReadyForAgendaTransfer) {
    <icz-tag label="Připraveno k rozluce" color="orange" class="mr-16"></icz-tag>
  }
  @if (isAgendaTransferConfirmed) {
    <icz-tag label="Rozluka potvrzena" color="orange" class="mr-16"></icz-tag>
  }
  <icz-icon [svgIcon]="bigIcon" [iczTooltip]="'en.objectClass.' + object.objectClass"></icz-icon>
  <div class="col grow">
    <div class="row">
      @if (!hasProfilePermission && applicationConfigService.objectExistenceCheckObjectMetadataVisible()) {
        <icz-tag color="grey" label="Omezený náhled" svgIcon="eye"></icz-tag>
      }
      @if (object.documentState && object.documentState !== DocumentState.IN_PROGRESS) {
        <icz-tag [label]="'en.documentState.' + object.documentState" [color]="getObjectTagColor($any(object))"></icz-tag>
      }
      @if (!isIssdActivity) {
        @if ((canShowDocumentActivities$ | async) && runningActivity) {
          <icz-task-activity-state-icon
            [activity]="runningActivity"
            (circulationActionCompleted)="onCirculationActionCompleted()"
          ></icz-task-activity-state-icon>
        }
      }
      @if ($any(object).isSharedWithCurrentUser) {
        <icz-tag color="orange" label="Nasdíleno"></icz-tag>
      }
      @if (isRegistryOfficeTransferActivityView) {
        <icz-tag [color]="registryOfficeTransferTagColor" [label]="registryOfficeTransferTagLabel"></icz-tag>
      }
      @if (isSharedInAccessibleFolder$ | async) {
        <icz-tag color="blue" label="Ve složce" svgIcon="substitute"></icz-tag>
      }
      <icz-label class="uuid" [label]="object.uid?.uid"></icz-label>
    </div>
    <div class="truncate">
      @if (object.refNumber) {
        <span class="ref-number">{{ object.refNumber }}</span>
      }
      @else if (hasProfilePermission || applicationConfigService.objectExistenceCheckObjectRefNumberVisible()) {
        {{ 'Bez čísla jednacího' | translate }}
      }
      @if (object.subject) {
        <span class="font-bold" [iczTooltip]="object.subject">
          @if (object.refNumber || hasProfilePermission || applicationConfigService.objectExistenceCheckObjectRefNumberVisible()) {
            -
          }
          {{ object.subject }}
        </span>
      }
    </div>
  </div>
  @if (
    isAuthorizedOperationGranted(object.authorization, DocumentAuthorizedOperation.DOCUMENT_SHOW_PROFILE) &&
    !loadingService.isLoading(documentDetailService)
  ) {
    @if (isInCirculationSolvingMode) {
      <icz-circulation-toolbar-buttons
        [view]="circulationToolbarView"
        [selectedRows]="[object]"
        [refActivity]="refActivity"
        [refTask]="refTask"
      ></icz-circulation-toolbar-buttons>
    }
    @else {
      <icz-document-toolbar-buttons
        [view]="DocumentView.DOCUMENT_DETAIL"
        [selectedRows]="[object]"
        [parentFile]="parentFile$ | async"
        [isRegistryOfficeTransferActivityView]="isRegistryOfficeTransferActivityView"
        [runningCirculationActivity]="runningActivity"
      ></icz-document-toolbar-buttons>
    }
  }
  <div class="div-splitter"></div>
  <icz-entity-comments-viewer [isInTable]="false" [document]="object" [disabled]="!allowComments"></icz-entity-comments-viewer>
}
